import { render, staticRenderFns } from "./RappiItem.vue?vue&type=template&id=55bda3ee"
import script from "./RappiItem.vue?vue&type=script&lang=js"
export * from "./RappiItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports